// extracted by mini-css-extract-plugin
module.exports = {"headerTitleColumn":"AdminProjectManagement_headerTitleColumn_jUtbI","tableName":"AdminProjectManagement_tableName_JdIvh","spinAround":"AdminProjectManagement_spinAround_1h8L3"};